
import datawinGetActions from './datawin';
import documentGetActions from './document';
import getDataModelDefinitionGetActions from './getDataModelDefinition';
import infoGetActions from './info';
import operationGetActions from './operation';

export * from './datawin';
export * from './document';
export * from './getDataModelDefinition';
export * from './info';
export * from './operation';

export function getActions(dispatch) {
    return {
        ...datawinGetActions(dispatch),
        ...documentGetActions(dispatch),
        ...getDataModelDefinitionGetActions(dispatch),
        ...infoGetActions(dispatch),
        ...operationGetActions(dispatch)
    }
}
